import initDesktopAppCard from './job-page-desktop-app-card';

function getConfig() {
  return window.jobPageApp || null;
}

function syncMobileBannerTopOffset(banner, header) {
  // Header scrolls with page; once past viewport top, pin fixed banner flush (see CSS).
  const headerPastViewport = header.getBoundingClientRect().bottom <= 0;
  banner.classList.toggle('job-page-app-banner--flush-top', headerPastViewport);
}

function bindMobileBannerTopSync(banner, header) {
  let ticking = false;
  function scheduleSync() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      syncMobileBannerTopOffset(banner, header);
    });
  }

  syncMobileBannerTopOffset(banner, header);
  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleSync);
    window.visualViewport.addEventListener('scroll', scheduleSync);
  }
}

function initMobileBanner(onelink) {
  const banner = document.getElementById('job-page-app-banner');
  if (!banner) return;

  const header = document.querySelector('.header.h57px') || document.querySelector('.header');
  if (header) {
    bindMobileBannerTopSync(banner, header);
  }

  const openBtn = banner.querySelector('.job-page-app-banner__open');
  const closeBtn = banner.querySelector('.job-page-app-banner__close');
  if (openBtn) openBtn.addEventListener('click', () => { window.location.href = onelink; });
  if (closeBtn) closeBtn.addEventListener('click', () => { banner.classList.add('is-hidden'); });
}

function initApplySheet(onelink) {
  const sheet = document.getElementById('job-page-app-sheet');
  if (!sheet) return;

  let pendingHref = '';

  function closeSheet() {
    sheet.classList.remove('is-visible');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('job-page-app-sheet-open');
  }

  $(document).on('click', 'a.js-job-page-app-apply', function appApplyClick(e) {
    e.preventDefault();
    pendingHref = $(this).attr('href') || '';
    sheet.classList.add('is-visible');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('job-page-app-sheet-open');
  });

  sheet.querySelectorAll('.js-job-page-app-sheet-close').forEach((el) => {
    el.addEventListener('click', closeSheet);
  });

  const appBtn = sheet.querySelector('.js-job-page-app-sheet-app');
  if (appBtn) appBtn.addEventListener('click', () => { window.location.href = onelink; });

  const webBtn = sheet.querySelector('.js-job-page-app-sheet-web');
  if (webBtn) {
    webBtn.addEventListener('click', () => {
      if (pendingHref) window.location.href = pendingHref;
    });
  }

  $(document).on('keydown.jobPageAppSheet', (ev) => {
    if (ev.key !== 'Escape') return;
    if (!sheet.classList.contains('is-visible')) return;
    closeSheet();
  });
}

function init() {
  const cfg = getConfig();
  if (!cfg || !cfg.onelink) return;

  initMobileBanner(cfg.onelink);
  initApplySheet(cfg.onelink);
  initDesktopAppCard(cfg);
}

$(init);
